module.exports = __webpack_public_path__ + "assets/3f2a90942fa4f9e2e29ca9e54dd6c223.json";